import React from "react";
import { ReactComponent as StarSVG } from "assets/img/vectors/homepage/star.svg";


const Star = () => (
    <StarSVG />
)

export default Star;